import React from 'react';
import Query from '../../../../../../graphql/Query';
import CategoryProductsListView, { CategoryProductsListViewProps } from './CategoryProductsListView';
import { GET_CATEGORY_PRODUCTS } from '../../../../graphql';

interface CategoryProductsListProps {
    categoryId: string;
}

const CategoryProductsList: React.FC<CategoryProductsListProps> = ({ categoryId }) => {
    return (
        <Query<CategoryProductsListViewProps>
            query={GET_CATEGORY_PRODUCTS}
            variables={{ categoryId }}
        >
            {({ data: { productsByCategory } }) => (
                <CategoryProductsListView
                    productsByCategory={productsByCategory}
                />
            )}
        </Query>
    );
};

export default CategoryProductsList;
